import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { fetchBanners } from 'slices/banners'
import { setDrawer } from 'slices/drawer'
import { DRAWER_KEY } from 'app-constants'
import { Button } from 'components/button'
import { SuccessActivate, SuccessInfo, SuccessMessage } from './components'
import './style.scss'

export function Success({ cart = [], setActivationInfo, setHideBackButton }) {
  const {
    selected: { id: contractId },
  } = useSelector(({ contract }) => contract)
  const dispatch = useDispatch()

  useEffect(() => {
    if (setHideBackButton) setHideBackButton(true)
  }, [setHideBackButton])

  function handleCloseClick() {
    dispatch(fetchBanners(contractId))
    dispatch(setDrawer(DRAWER_KEY.NONE))
  }

  return (
    <div className='container-success-purchase'>
      <SuccessMessage />
      <SuccessInfo cart={cart} />
      <SuccessActivate setActivationInfo={setActivationInfo} />
      <Button color='primary' type='button' onClick={handleCloseClick} className='button'>
        Tela Inicial
      </Button>
    </div>
  )
}
